export const ViewWorkCitedTooltipText = 'View full-text citations';
